import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { WifiOff, Wifi } from 'lucide-react';
import { usePWA } from '../../hooks/usePWA';

const OfflineIndicator: React.FC = () => {
  const { isOnline } = usePWA();
  const [showOfflineMessage, setShowOfflineMessage] = React.useState(false);

  React.useEffect(() => {
    if (!isOnline) {
      setShowOfflineMessage(true);
    } else {
      // Hide the message after a delay when coming back online
      const timer = setTimeout(() => {
        setShowOfflineMessage(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isOnline]);

  return (
    <AnimatePresence>
      {showOfflineMessage && (
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          className="fixed top-20 left-4 right-4 z-50"
        >
          <div className={`mx-auto max-w-sm rounded-lg p-3 shadow-lg ${
            isOnline 
              ? 'bg-green-600 text-white' 
              : 'bg-yellow-600 text-white'
          }`}>
            <div className="flex items-center">
              {isOnline ? (
                <Wifi className="w-5 h-5 mr-2" />
              ) : (
                <WifiOff className="w-5 h-5 mr-2" />
              )}
              <div>
                <p className="font-medium text-sm">
                  {isOnline ? 'Connection restored' : 'Offline mode'}
                </p>
                <p className="text-xs opacity-90">
                  {isOnline 
                    ? 'All features are available' 
                    : 'Some features might be limited'
                  }
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default OfflineIndicator;